import React from "react";
import { Link } from "react-router-dom";
import TerminosCondiciones from "../../components/TerminosCondiciones";
import imgLogo from "../../assets/logo.png";
import whatsapp_logo from "../../assets/whatsapp_logo.png";
import email_logo from "../../assets/email_logo.png";


import "./styles.css";

const Render = (props, context) => {
  return (
    <div>
      <section className="preSite coverAll">
        <div className="container">
          <h1 className="mbl">
            <img
              src={imgLogo}
              alt="Superheroes."
              className="logo displayBlock mha"
            />
          </h1>

          {props.error && (
            <p className={`formMsg pvl mha white alignCenter`}>{props.error}</p>
          )}

          <form className="mha" onSubmit={props.submit}>
            <label htmlFor="nombre">
              {/* <span className="labelName">Usuario</span> */}
              <input
                type="text"
                id="nombre"
                className="nombre"
                value={props.username}
                onChange={props.handleUsernameChange}
                placeholder="USUARIO"
              />
            </label>

            <label htmlFor="passwordLogin">
              {/* <span className="labelName">Contraseña</span> */}
              <input
                type="password"
                name="passwordLogin"
                id="passwordLogin"
                className="passwordLogin"
                value={props.password}
                onChange={props.handlePasswordChange}
                placeholder="CONTRASEÑA"
              />
            </label>
            <p className="formNote pvl phm white alignCenter">
              Al ingresar aceptas los{" "}
              <a onClick={props.toggleTerms} className="white underline">
                Términos y condiciones
              </a>{" "}
              de la plataforma
            </p>

            <input type="submit" value="Ingresar" className="btn mha btnGold fontGold" />
          </form>

          <ul className="formNote horizontalCenter clearfix ptl">
            <li>
              <Link to="/recuperar-pass" className="phm white">
                ¿Olvidaste tu contraseña?
              </Link>
            </li>
            <li>
              <Link to="/register" className="phm white">
                ¿No estás autentificado? Autentificate
              </Link>
            </li>
            <li className="mail-wpp">
              <a href="https://wa.me/5491126864447?text=Hola%20quería%20hacerte%20una%20consulta:" className="phm white">
                <img src={whatsapp_logo} title="whatsapp" alt="whatsapp"  height="30px"/>
              </a>
              <a href="mailto:atencionsuperheroes@mg54.com" className="phm white">
                <img src={email_logo} title="whatsapp" alt="whatsapp" height="30px" />
              </a>
            </li>
          </ul>
        </div>
      </section>
      {props.terms && <TerminosCondiciones onClose={props.toggleTerms} />}
    </div>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Login/Render.js